import {
  composeRenderProps,
  ToggleButton,
  type ToggleButtonProps,
} from "react-aria-components";
import toggleButtonStyles from "./ToggleButton.module.scss";
import singleToggleButtonStyles from "./SingleToggleButton.module.scss";

export const SingleToggleButton = (props: ToggleButtonProps) => {
  return (
    <ToggleButton
      {...props}
      className={composeRenderProps(props.className, (className) =>
        [
          toggleButtonStyles.toggleButton,
          singleToggleButtonStyles.singleToggleButton,
          className,
        ]
          .filter(Boolean)
          .join(" "),
      )}
    />
  );
};
